<template>
  <div class="logistics-container">
    <div class="com-detail-hd">
      <detail-header></detail-header>
    </div>
    <div class="logisticsIndex-container">
      <div class="logisticsIndex-sort">
        <p>排序</p>
        <p class="btn"
           @click="toggle(1)"
           :class="this.$route.params.State==1?active:''">按状态</p>
        <p class="btn"
           @click="toggle(0)"
           :class="this.$route.params.State==0?active:''">按时间</p>
      </div>
      <detail-aside createText="我要下单"
                    :imgSrc="imgSrc"
                    @open="open"
                    :IsLogin="IsLogin"
                    :CanOperat="CanOperat"
                    @init="init"></detail-aside>
      <div class="logisticsIndex-page">
        <div class="logisticsIndex-list">
          <table>
            <tr>
              <th>流水号</th>
              <th>合同号</th>
              <th>下单时间</th>
              <th>下单信息</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
            <tr class="hover"
                v-for="(item) of rows"
                :key="item.Id"
                @click="showLgDetails(item.Id)">
              <td>{{item.Id}}</td>
              <td>{{item.ContractNumber}}</td>
              <td>{{item.CreatedTime}}</td>
              <td>
                <span class="remarks">{{item.Remarks}}</span>
              </td>
              <td :style="item.OrderState == 1 || item.OrderState == 2 ? {color:'#3cd190'} : ''">{{item.OrderState | orderState}}</td>
              <td :style="item.OrderState == 1 || item.OrderState == 2 ? {color:'#5fb6de',textDecoration:'underline'} : {cursor:'default'}"
                  @click.stop="cancelConfirm(item.Id,item.OrderState)">取消订单</td>
            </tr>
          </table>
        </div>
        <el-pagination background
                       layout="prev,pager,next"
                       prev-text="上一页"
                       next-text="下一页"
                       :total="total"
                       @current-change="pageChange"
                       :current-page="pages"></el-pagination>
      </div>
    </div>

    <d-lg-details v-if="lgDetailsShow"
                  :orderId="orderId"
                  :IsLogin="IsLogin"
                  @closeLgD="closeLgD"
                  @showLargePic="showLargePic(arguments)"></d-lg-details>

    <d-Swiper :currentImgList="currentImgList"
              :activeIndex="activeIndex"
              @closeLargePic="closeLargePic"
              v-if="largePicShow"></d-Swiper>
  </div>
</template>

<script>
import "../../../../html/pages/originality/logisticsIndex/logisticsIndex.scss"

import detailHeader from '../visaflow/components/detailHeader'
import detailAside from '../visaflow/components/detailAside'
import dLgDetails from './components/d-lgDetails'
import dSwiper from '../visaflow/components/d-swiper'

import { GetLogisticsList, CancelLogistics } from '../../../../api/index'

export default {
  data () {
    return {
      imgSrc: require('../../../../html/pages/originality/logisticsIndex/images/order.png'),
      active: {
        active: true
      },
      rows: [],
      lgDetailsShow: false,
      orderId: '',
      CanOperat: false,
      IsLogin: false,
      total: 1,
      pages: 1,
      currentImgList: [],
      activeIndex: '',
      largePicShow: false
    }
  },
  methods: {
    closeLgD () {
      this.lgDetailsShow = false;
      this.init();
    },
    pageChange (pageIndex) {
      this.$router.push(`/originality/logisticsindex/${this.$route.params.id}/${pageIndex}/${this.$route.params.State}`)
    },
    open () {
      this.$router.push(`/originality/logisticsorder/${this.$route.params.id}`)
    },
    async init () {
      let res = await GetLogisticsList({
        ForumId: this.$route.params.id,
        State: this.$route.params.State,
        pageIndex: this.$route.params.pageIndex,
        pageSize: 10
      })
      // console.log(res);
      if (res.Type == "Success") {
        this.rows = res.Data.Data.rows;
        this.total = res.Data.Data.total;
        this.pages = res.Data.Data.pages;
        this.CanOperat = res.Data.CanOperat;
        this.IsLogin = res.Data.IsLogin;
      }
    },
    toggle (i) {
      this.$router.push(`/originality/logisticsindex/${this.$route.params.id}/1/${i}`)
    },
    cancelConfirm (id, orderState) {
      if (orderState < 3) {
        this.$layer.confirm('是否取消订单', (layerid) => {
          this.$layer.close(layerid)
          this.cancel(id)
        })
      }
    },
    async cancel (id) {
      let res = await CancelLogistics({
        id
      });
      // console.log(res);
      if (res.Type == "Error" || res.Type == "Warning") {
        this.$layer.alert(res.Content);
      } else if (res.Type == "Success") {
        this.$layer.alert('取消成功', (layerid) => {
          this.$layer.close(layerid);
          this.init();
        })
      }
    },
    showLgDetails (id) {
      this.lgDetailsShow = true;
      this.orderId = id;
    },
    showLargePic (dataList) {
      this.lgDetailsShow = false;
      this.largePicShow = true;
      this.currentImgList = dataList[0].split(",");
      this.activeIndex = dataList[1];
    },
    closeLargePic () {
      this.lgDetailsShow = true;
      this.largePicShow = false;
    },
  },
  components: {
    detailHeader,
    detailAside,
    dLgDetails,
    dSwiper
  },
  beforeRouteUpdate (to, from, next) {
    next();
    this.init();
  },
  created () {
    this.init();
  },
  filters: {
    orderState (status) {
      switch (status) {
        case 1:
          return "等待负责人确定";
        case 2:
          return "等待中心领导确定";
        case 3:
          return "等待分管领导确定";
        case 4:
          return "等待总经理确定";
        case 5:
          return "等待协理确定";
        case 6:
          return "已发货";
      }
    }
  },
}
</script>